import { camelizeKeys } from '~/redux/api/transformers/utils';
import { ServiceRequestConfig } from '~/services/createService';
import { managedEntities } from '~/services/serviceInstances';

import { JsonApiListResponse, PaginatedMeta } from '../../ApiTypes';
import { GroupNodeAttributesServer } from './types';

interface GetGroupNodeParams {
  nodeId: string;
}

export const getGroupNodeChildren = async (
  { nodeId }: GetGroupNodeParams,
  options: ServiceRequestConfig = {},
) => {
  const { data, meta } = await managedEntities.get<
    JsonApiListResponse<'nodes', GroupNodeAttributesServer, PaginatedMeta>
  >(`/nodes/${nodeId}/children`, options);

  return {
    data: data.map((node) => camelizeKeys(node)),
    meta,
  };
};
